import React from 'react';
import CustomDropdown from '../shared/CustomDropdown';

/**
 * Time Period Filter Component
 * Shows predefined time periods up to the 15-day retention limit
 */
const TimePeriodFilter = ({ value, onChange }) => {
  
  const handlePeriodChange = (newValue) => {
    // All periods are predefined, no custom picker needed
    onChange(newValue, null, null);
  };

  // Predefined time periods up to 15-day retention
  const dropdownOptions = [
    { value: 'all', label: 'All Time (15 days)' },
    { divider: true },
    { value: '1h', label: 'Last 1 Hour', icon: '🕐' },
    { value: '6h', label: 'Last 6 Hours', icon: '🕕' },
    { value: '12h', label: 'Last 12 Hours', icon: '🕛' },
    { value: '24h', label: 'Last 24 Hours', icon: '📅' },
    { divider: true },
    { value: '3d', label: 'Last 3 Days', icon: '📆' },
    { value: '7d', label: 'Last 7 Days', icon: '📆' },
    { value: '15d', label: 'Last 15 Days', icon: '📆' }
  ];

  return (
    <div className="relative">
      <CustomDropdown
        label="Time Period"
        options={dropdownOptions}
        value={value.type}
        onChange={handlePeriodChange}
        placeholder="Select time period"
      />
    </div>
  );
};

export default TimePeriodFilter;